import type { IExtractParams } from "@routes/types.ts";
import { generatePath } from "@routes/utils.ts";

const pathBase = `/members/:memberId/papers/:paperId/disapprove/`;

export type IPaperDisapprovePathParam = IExtractParams<typeof pathBase>;

export const paperDisapprove = {
  post: (params: IPaperDisapprovePathParam) => generatePath(pathBase, params),
};
